import { render, staticRenderFns } from "./teachingmat.vue?vue&type=template&id=680bf0dc&scoped=true&"
import script from "./teachingmat.vue?vue&type=script&lang=js&"
export * from "./teachingmat.vue?vue&type=script&lang=js&"
import style0 from "./teachingmat.vue?vue&type=style&index=0&id=680bf0dc&lang=scss&scoped=true&"
import style1 from "./teachingmat.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680bf0dc",
  null
  
)

export default component.exports